import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Hidden, Visible } from 'components/Grid';

import { Container, Text, Icon } from './styles';

const BASE_URL = process.env.REACT_APP_APPLICATION_BASE_URL;

const LoginButton = () => {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <Container href={`${BASE_URL}/${location.search}`}>
      <Hidden xs>
        <Icon src="/assets/icons/hero/login.svg" alt="login" />
        <Text>{t('HERO.LOGIN')}</Text>
      </Hidden>
      <Visible xs>
        <Icon.xs src="/assets/icons/hero/login.svg" alt="login" />
        <Text.xs>{t('HERO.LOGIN')}</Text.xs>
      </Visible>
    </Container>
  );
};

export default LoginButton;
